import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

import { environment } from '../../../environments/environment';
import { TelemetryEventAttributes, TelemetryEventName } from './telemetry-events';

/** Centralized, best-effort Datadog RUM dispatch — the only place event sending logic lives. */
@Injectable({ providedIn: 'root' })
export class TelemetryService {
  trackEvent<K extends TelemetryEventName>(name: K, attributes: TelemetryEventAttributes[K]): void {
    if (!environment.datadog?.enabled) return;

    try {
      datadogRum.addAction(name, { event_id: crypto.randomUUID(), ...attributes });
    } catch {
      // Telemetry must never break the calling feature.
    }
  }

  clearUser(): void {
    if (!environment.datadog?.enabled) return;

    try {
      datadogRum.clearUser();
    } catch {
      // Telemetry must never break the calling feature.
    }
  }
}
